
import { AuditInstructionFileModel, FileModel } from '@/libs/Api';
import { authStore } from '@/libs/auth/+store/store';
import { AuthGetter } from '@/libs/auth/models/auth-state';
import Page from '@/Page.vue';
import axios from 'axios';
import { getAccessToken } from 'axios-jwt';
import { Component, VModel, Watch } from 'vue-property-decorator';
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';

@Component({
    components: { VuePdfEmbed },
})
export default class InstructionFilePreview extends Page {
    blobUrls: string[] = [];
    zoomedFiles: boolean[] = [];
    loadingFiles: boolean[] = [];

    @VModel() files!: AuditInstructionFileModel[];

    isImageFile(file: FileModel | null | undefined): boolean {
        const imageTypes = ['image/jpeg', 'image/png', 'image/svg+xml', 'image/heic'];
        return imageTypes.some((type) => type === file?.contentType);
    }

    isPdfFile(file: FileModel | null | undefined): boolean {
        const pdfTypes = ['application/pdf'];
        return pdfTypes.some((type) => type === file?.contentType);
    }

    mounted() {
        this.loadAllFiles();
    }

    @Watch('files', { deep: true })
    onFilesChanged() {
        this.loadAllFiles();
    }

    loadAllFiles() {
        if (!this.files || this.files.length === 0) {
            this.blobUrls = [];
            this.zoomedFiles = [];
            this.loadingFiles = [];
            return;
        }

        // Inicializace polí
        this.blobUrls = new Array(this.files.length).fill('');
        this.zoomedFiles = new Array(this.files.length).fill(false);
        this.loadingFiles = new Array(this.files.length).fill(false);

        // Načtení všech souborů
        this.files.forEach((fileItem, index) => {
            if (fileItem.file) {
                this.loadFile(fileItem.file, index);
            }
        });
    }

    loadFile(file: FileModel, index: number) {
        if (!file || !file.id) return;

        this.$set(this.loadingFiles, index, true);
        const tenantId = authStore.useGetter(AuthGetter.GetTenant);
        const token = getAccessToken();

        axios({
            url: (window as any).ApiService.baseUrl + '/api/files/' + file.id! + '/download',
            method: 'GET',
            responseType: 'blob',
            headers: {
                TenantId: tenantId,
                Authorization: `Bearer ${token}`,
            },
        })
            .then((response) => {
                this.$set(this.loadingFiles, index, false);
                const url = window.URL.createObjectURL(new Blob([response.data], { type: file.contentType! }));
                this.$set(this.blobUrls, index, url);
            })
            .catch(() => {
                this.$set(this.loadingFiles, index, false);
            });
    }

    toggleZoom(index: number) {
        this.$set(this.zoomedFiles, index, !this.zoomedFiles[index]);
    }

    downloadFileByIndex(index: number) {
        const fileItem = this.files[index];
        const blobUrl = this.blobUrls[index];

        if (fileItem && fileItem.file && blobUrl) {
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = fileItem.file.fileName || 'download';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
}
